var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/menu-reset-password.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-22e92bc4!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/menu-reset-password.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MenuResetPassword.vue
// module id = 1318
// module chunks = 1